import apiClient from '../../utils/axiosConfig';
import type { UserProfile, ProfileUpdateData } from './types';
import { PROFILE_ENDPOINTS } from './constants';

export const profileService = {
  async getCurrentUser(): Promise<UserProfile> {
    const response = await apiClient.get<UserProfile>(PROFILE_ENDPOINTS.CURRENT_USER);
    return response.data;
  },

  async updateUserProfile(data: ProfileUpdateData): Promise<UserProfile> {
    const response = await apiClient.patch<UserProfile>(
      PROFILE_ENDPOINTS.CURRENT_USER,
      data
    );
    return response.data;
  },

  async uploadUserPhoto(photoFile: File): Promise<UserProfile> {
    const formData = new FormData();
    formData.append('photo', photoFile);

    const response = await apiClient.post<UserProfile>(
      PROFILE_ENDPOINTS.UPLOAD_PHOTO,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },
};


